/* eslint-disable new-cap */
import Sniffer from 'sniffer';
import { webgl, slider, app } from '@/utils/store';
import texture from '@/assets/img/609-normal.jpg';

// slider
import nodata from '@/components/slider/data';

// scene
import webglApp from '@/utils/scene';

const data = nodata[app.language];

class Webgl {
  constructor() {
    this.webgl = document.getElementById('a-webgl');
  }

  init() {
    let mouse;

    if (Sniffer.isDevice) {
      mouse = false;
    } else {
      mouse = true;
    }

    if (webglApp.default) {
      webglApp = webglApp.default;
    }

    webgl.app = new webglApp({
      container: this.webgl,
      shadowMouseMove: mouse,
      manifest: [
        { name: 'normalmap', url: texture },
      ],
    });

    webgl.loaded = false;

    webgl.app.load().then(() => {
      webgl.app.start();

      window.addEventListener('resize', () => {
        webgl.app.resize(window.innerWidth, window.innerHeight);
      });

      // play webgl
      webgl.app.play();

      // object depth
      if (Sniffer.isPhone) {
        webgl.app.depth = 110;
      } else {
        webgl.app.depth = 70;
      }

      // object Y position in pixel
      if (app.loading === true || app.contact === true) {
        webgl.app.offsetY = -window.innerHeight * 2;
      } else {
        webgl.app.offsetY = 0;
      }

      // object X position in pixel
      if (Sniffer.isPhone) {
        webgl.app.offsetX = -window.innerWidth * 0.3;
      }

      webgl.app.objColor = data.slides[slider.current].c;

      // animate value from 0 to 3
      webgl.app.animate = slider.current;
      webgl.app.paperGrain = 0.43;

      // on the wall shadow setting
      if (Sniffer.isPhone) {
        webgl.app.shadowBlur = 4.96;
      } else {
        webgl.app.shadowBlur = 6.96;
      }

      if (Sniffer.isPhone) {
        webgl.app.cameraRotationX = -0.8;
        webgl.app.cameraRotationY = 0.22;
      }

      webgl.app.shadowDarkness = 5;
      webgl.app.shadowOpacity = 1;

      // on object self light setting
      webgl.app.lightAngle = 1.047;
      webgl.app.lightPenumbra = 0;
      webgl.app.lightShadowRadius = 3;

      window.dat = webgl.app;

      webgl.loaded = true;
    });
  }
}

export default Webgl;
